import { UPLOAD_STRINGS } from "@/lib/uploadI18n";

// Copy for the two AI sample-role generation paths. Resume mode explicitly
// tells the user that only the reviewed post-Privacy Scan résumé text is used.
export const SAMPLE_ROLE_COPY = {
  en: {
    jdSampleChoiceH: "How should AI create your practice role?",
    jdSampleFromResume: "Create a practice role based on my résumé",
    jdSampleFromResumeSub: "AI will use the résumé text you reviewed after the Privacy Scan to create a realistic role suited to your experience.",
    jdSampleSpecified: "Let me choose the type of role",
    jdSampleSpecifiedSub: "Select a professional category and role level, and optionally describe the role you want to practise for. Your résumé is not used to create this job description.",
    jdSampleResumeNotReady: "Review and approve your post-Privacy Scan résumé above before generating a role from it.",
  },
  "pt-BR": {
    jdSampleChoiceH: "Como a IA deve criar sua vaga de prática?",
    jdSampleFromResume: "Criar uma vaga de prática com base no meu currículo",
    jdSampleFromResumeSub: "A IA usará o texto do currículo que você revisou após a Verificação de Privacidade para criar uma vaga realista adequada à sua experiência.",
    jdSampleSpecified: "Quero escolher o tipo de vaga",
    jdSampleSpecifiedSub: "Selecione uma categoria profissional e o nível da vaga e, se quiser, descreva a função para a qual deseja praticar. Seu currículo não será usado para criar esta descrição de vaga.",
    jdSampleResumeNotReady: "Revise e aprove seu currículo após a Verificação de Privacidade acima antes de gerar uma vaga com base nele.",
  },
  "es-419": {
    jdSampleChoiceH: "¿Cómo debe crear la IA su puesto de práctica?",
    jdSampleFromResume: "Crear un puesto de práctica basado en mi currículum",
    jdSampleFromResumeSub: "La IA usará el texto del currículum que usted revisó después del Análisis de Privacidad para crear un puesto realista acorde con su experiencia.",
    jdSampleSpecified: "Quiero elegir el tipo de puesto",
    jdSampleSpecifiedSub: "Seleccione una categoría profesional y el nivel del puesto y, si lo desea, describa el rol para el que quiere practicar. Su currículum no se utilizará para crear esta descripción del puesto.",
    jdSampleResumeNotReady: "Revise y apruebe arriba su currículum después del Análisis de Privacidad antes de generar un puesto basado en él.",
  },
  "fr-CA": {
    jdSampleChoiceH: "Comment l’IA doit-elle créer votre poste d’entraînement?",
    jdSampleFromResume: "Créer un poste d’entraînement à partir de mon CV",
    jdSampleFromResumeSub: "L’IA utilisera le texte du CV que vous avez révisé après l’Analyse de confidentialité afin de créer un poste réaliste adapté à votre expérience.",
    jdSampleSpecified: "Je veux choisir le type de poste",
    jdSampleSpecifiedSub: "Sélectionnez une catégorie professionnelle et un niveau de poste et, si vous le souhaitez, décrivez le rôle pour lequel vous voulez vous exercer. Votre CV ne sera pas utilisé pour créer cette description de poste.",
    jdSampleResumeNotReady: "Révisez et approuvez votre CV après l’Analyse de confidentialité ci-dessus avant de générer un poste à partir de celui-ci.",
  },
};

for (const lang of Object.keys(UPLOAD_STRINGS)) {
  Object.assign(UPLOAD_STRINGS[lang], SAMPLE_ROLE_COPY[lang] || SAMPLE_ROLE_COPY.en);
}

export const COPY = {
  // Shown when the résumé language gate rejects an upload (INTERVIEW_ENGINE_RULES.md A11):
  // bilingual résumés are accepted, so the message is about the majority of the content.
  en: "All or the majority of this résumé is in a language other than English. Please review and upload a résumé with all or the majority of its content in English.",
  "pt-BR": "Todo ou a maior parte deste currículo está em um idioma diferente do inglês. Revise-o e envie um currículo com todo ou a maior parte do conteúdo em inglês.",
  "es-419": "Todo o la mayor parte de este currículum está en un idioma distinto del inglés. Revíselo y suba un currículum con todo o la mayor parte de su contenido en inglés.",
  "fr-CA": "Ce CV est rédigé entièrement ou majoritairement dans une langue autre que l’anglais. Veuillez le réviser et téléverser un CV dont la totalité ou la majorité du contenu est en anglais.",
};

export function englishResumeRequiredMessage(lang) {
  return COPY[lang] || COPY.en;
}
